import { useMutation } from 'react-query';

export default function useCreateAccountAndSignIn() {
  return useMutation(
    async (params: {
      accountName: string | undefined;
      userFirstName: string | undefined;
      userLastName: string | undefined;
    }) => {
      const response = await fetch(`/auth/stytch/discovery/create`, {
        method: 'POST',
        body: JSON.stringify({
          account_name: params.accountName,
          user_first_name: params.userFirstName,
          user_last_name: params.userLastName,
          anonymous_id: window.analytics?.user()?.anonymousId(),
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        return { isSuccess: true };
      } else {
        const data = await response.json();
        return { isSuccess: false, error: data };
      }
    },
  );
}
